export default __webpack_public_path__ + "static/media/greece.604fb542.webp";